import Swal from 'sweetalert2';
import { Color } from '../../assets/color';
import * as actionTypes from "../action-types";
import { deleteAPI, getAPI, patchAPI, postAPI } from '../../utils/api-function';
import { put, call, takeLeading } from 'redux-saga/effects';
import {
    //* Partner
    get_partners, get_partner_by_id, create_partner, update_partner, delete_partner, change_partner_status,

    //* Customer
    get_customer_by_partnerId, get_affiliate_by_partnerId, get_customer_by_affiliateId,

    //* Partner Report Wallet
    get_partner_report_wallets, create_partner_report_wallet, update_partner_report_wallet, delete_partner_report_wallet

} from '../../utils/api-routes';

function* getPartners(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload);

        const { data } = yield getAPI(get_partners(payload));
        console.log("Get Partners Saga Saga Response ::: ", data);

        if (data?.status) {
            yield put({ type: payload?.label == 'Partner' ? actionTypes.SET_PARTNERS : actionTypes.SET_AFFILIATES, payload: data.result });
        } else {
            yield put({ type: actionTypes.SET_PARTNERS, payload: [] });
        }

    } catch (error) {
        console.log("Get Partners Saga Error ::: ", error);
        yield put({ type: actionTypes.SET_PARTNERS, payload: [] });
        Swal.fire({ icon: 'error', text: error?.response?.data?.message, showConfirmButton: false, timer: 10000 });
    }
};

function* getPartnerById(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload);

        const { data } = yield getAPI(get_partner_by_id(payload));
        console.log("Get Partner By ID Saga Response ::: ", data);

        if (data?.status) {
            yield put({ type: actionTypes.SET_PARTNER_BY_ID, payload: data.result });
        }

    } catch (error) {
        console.log("Get Partner By ID Saga Error ::: ", error);
        yield put({ type: actionTypes.SET_PARTNER_BY_ID, payload: {} });
        Swal.fire({ icon: 'error', text: error?.response?.data?.message, showConfirmButton: false, timer: 10000 });
    }
};

function* createPartner(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload);

        const result = yield Swal.fire({ icon: "warning", title: `Are you sure ?`, text: "You want to create this partner?", showCancelButton: true, confirmButtonColor: Color.primary, cancelButtonColor: Color.red, confirmButtonText: "Yes" });

        if (result.isConfirmed) {
            const { data } = yield postAPI(create_partner, payload?.data);
            console.log("Create Partner Saga Response ::: ", data);

            if (data?.status) {
                Swal.fire({ icon: "success", text: data?.message, showConfirmButton: false, timer: 2000 });
                yield call(payload?.onComplete);
            } else {
                Swal.fire({ icon: "info", text: data?.message, showConfirmButton: false, timer: 20000 });
            }
        }

    } catch (error) {
        console.log("Create Partner Saga Error ::: ", error);
        Swal.fire({ icon: "error", text: error?.response?.data?.message, showConfirmButton: false, timer: 20000 });
    }
};

function* updatePartner(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload);

        const result = yield Swal.fire({ icon: "warning", title: `Are you sure ?`, text: "You want to update this partner?", showCancelButton: true, confirmButtonColor: Color.primary, cancelButtonColor: Color.red, confirmButtonText: "Yes" });

        if (result.isConfirmed) {
            const { data } = yield patchAPI(update_partner(payload?.id), payload?.data);
            console.log("Update Partner Saga Response ::: ", data);

            if (data?.status) {
                Swal.fire({ icon: "success", text: data?.message, showConfirmButton: false, timer: 2000 });
                yield call(payload?.onComplete);
            } else {
                Swal.fire({ icon: "info", text: data?.message, showConfirmButton: false, timer: 20000 });
            }
        }

    } catch (error) {
        console.log("Update Partner Saga Error ::: ", error);
        Swal.fire({ icon: "error", text: error?.response?.data?.message, showConfirmButton: false, timer: 20000 });
    }
};

function* deletePartner(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload);

        const result = yield Swal.fire({ icon: "warning", title: `Are you sure ?`, text: "You want to delete this partner?", showCancelButton: true, confirmButtonColor: Color.primary, cancelButtonColor: Color.red, confirmButtonText: "Delete" });

        if (result.isConfirmed) {
            const { data } = yield deleteAPI(delete_partner(payload?.id));
            console.log("Delete Partner Saga Response ::: ", data);

            if (data?.status) {
                Swal.fire({ icon: "success", text: data?.message, showConfirmButton: false, timer: 2000 });
                yield put({ type: actionTypes.GET_PARTNERS, payload: null });
            }
        }

    } catch (error) {
        console.log("Delete Partner Saga Error ::: ", error);
        Swal.fire({ icon: "error", text: error?.response?.data?.message, showConfirmButton: false, timer: 20000 });
    }
};

function* changePartnerStatus(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload);

        const result = yield Swal.fire({ icon: "warning", title: `Are you sure ?`, text: "You want to change the block status of this partner/affiliate?", showCancelButton: true, confirmButtonColor: Color.primary, cancelButtonColor: Color.red, confirmButtonText: "Yes" });

        if (result.isConfirmed) {
            const { data } = yield patchAPI(change_partner_status(payload?.id));
            console.log("Change Partner Status Saga Response ::: ", data);

            if (data?.status) {
                Swal.fire({ icon: "success", text: data?.message, showConfirmButton: false, timer: 2000 });
                yield put({ type: actionTypes.GET_PARTNERS, payload: null });
            } else {
                Swal.fire({ icon: "info", text: data?.message, showConfirmButton: false, timer: 20000 });
            }
        }

    } catch (error) {
        console.log("Change Partner Status Saga Error ::: ", error);
        Swal.fire({ icon: "error", text: error?.response?.data?.message, showConfirmButton: false, timer: 20000 });
    }
};

//* Customer
function* getCustomerByPartnerId(action) {
    try {
        const { payload } = action;
        console.log("Payload :::", payload);

        const { data } = yield getAPI(get_customer_by_partnerId(payload?.partnerId));
        console.log("Get Customer By PartnerId Saga Response :::", data);

        if (data?.status) {
            yield put({ type: actionTypes.SET_CUSTOMER_BY_PARTNERID, payload: data.result });
        } else {
            yield put({ type: actionTypes.SET_CUSTOMER_BY_PARTNERID, payload: null });
        }

    } catch (error) {
        console.error("Get Customer By PartnerId Saga Error :::", error);
        Swal.fire({ icon: 'error', text: error?.response?.data?.message || "Something went wrong", timer: 10000 });
        yield put({ type: actionTypes.SET_CUSTOMER_BY_PARTNERID, payload: null });
    }
};

//! Partner Report Wallet
function* getPartnerReportWallets() {
    try {
        const { data } = yield getAPI(get_partner_report_wallets);
        console.log("Partner Report Wallets Saga Response ::: ", data);

        if (data?.status) {
            yield put({ type: actionTypes.SET_PARTNER_REPORT_WALLETS, payload: data.result });
        } else {
            yield put({ type: actionTypes.SET_PARTNER_REPORT_WALLETS, payload: [] });
        }
    } catch (error) {
        console.log("Partner Report Wallets Saga Error ::: ", error);
        Swal.fire({ icon: "error", text: error?.response?.data?.message, showConfirmButton: false, timer: 10000 });
        yield put({ type: actionTypes.SET_PARTNER_REPORT_WALLETS, payload: [] });
    }
};

function* createPartnerReportWallet(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload);

        const result = yield Swal.fire({ icon: "warning", title: "Are you sure?", text: "You want to add token in partner wallet?", showCancelButton: true, confirmButtonColor: Color.primary, cancelButtonColor: Color.red, confirmButtonText: "Yes" });

        if (result.isConfirmed) {
            const { data } = yield postAPI(create_partner_report_wallet, payload?.data);
            console.log("Create Partner Report Wallet Saga Response ::: ", data);

            if (data?.status) {
                Swal.fire({ icon: "success", text: data.message, showConfirmButton: false, timer: 2000 });
                yield call(payload?.onComplete);
                yield put({ type: actionTypes.GET_PARTNER_REPORT_WALLETS });
            } else {
                Swal.fire({ icon: "info", text: data.message, showConfirmButton: false, timer: 10000 });
            }
        }
    } catch (error) {
        console.log("Create Partner Report Wallet Saga Error ::: ", error);
        Swal.fire({ icon: "error", text: error?.response?.data?.message, showConfirmButton: false, timer: 20000 });
    }
};

function* updatePartnerReportWallet(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload);

        const result = yield Swal.fire({ icon: "warning", title: "Are you sure?", text: "You want to update this entry and token in partner wallet?", showCancelButton: true, confirmButtonColor: Color.primary, cancelButtonColor: Color.red, confirmButtonText: "Yes" });

        if (result.isConfirmed) {
            const { data } = yield patchAPI(update_partner_report_wallet(payload?.id), payload?.data);
            console.log("Update Partner Report Wallet Saga Response ::: ", data);

            if (data?.status) {
                Swal.fire({ icon: "success", text: data.message, showConfirmButton: false, timer: 2000 });
                yield call(payload?.onComplete);
                yield put({ type: actionTypes.GET_PARTNER_REPORT_WALLETS });
            } else {
                Swal.fire({ icon: "info", text: data.message, showConfirmButton: false, timer: 10000 });
            }
        }
    } catch (error) {
        console.log("Update Partner Report Wallet Saga Error ::: ", error);
        Swal.fire({ icon: "error", text: error?.response?.data?.message, showConfirmButton: false, timer: 20000 });
    }
};

function* deletePartnerReportWallet(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload);

        const result = yield Swal.fire({ icon: "warning", title: "Are you sure?", text: "You want to delete this entry and token in partner wallet?", showCancelButton: true, confirmButtonColor: Color.primary, cancelButtonColor: Color.red, confirmButtonText: "Delete" });

        if (result.isConfirmed) {
            const { data } = yield deleteAPI(delete_partner_report_wallet(payload?.id));
            console.log("Delete Partner Report Wallet Saga Response ::: ", data);

            if (data?.status) {
                Swal.fire({ icon: "success", text: data.message, showConfirmButton: false, timer: 2000 });
                yield put({ type: actionTypes.GET_PARTNER_REPORT_WALLETS });
            }
        }
    } catch (error) {
        console.log("Delete Partner Report Wallet Saga Error ::: ", error);
        Swal.fire({ icon: "error", text: error?.response?.data?.message, showConfirmButton: false, timer: 20000 });
    }
};

function* getAffiliatesByPartnerId(action) {
    try {
        const { payload } = action;
        const { data } = yield getAPI(get_affiliate_by_partnerId(payload));
        if (data?.status) {
            yield put({ type: actionTypes.SET_AFFILIATE_BY_PARTNERID, payload: data.result });
        } else {
            yield put({ type: actionTypes.SET_AFFILIATE_BY_PARTNERID, payload: [] });
        }
    } catch (error) {
        yield put({ type: actionTypes.SET_AFFILIATE_BY_PARTNERID, payload: [] });
        Swal.fire({ icon: 'error', text: error?.response?.data?.message, showConfirmButton: false, timer: 10000 });
    }
};

function* getCustomersByAffiliateId(action) {
    try {
        const { payload } = action;
        const { data } = yield getAPI(get_customer_by_affiliateId(payload));
        if (data?.status) {
            yield put({ type: actionTypes.SET_CUSTOMER_BY_AFFILIATEID, payload: data.result });
        } else {
            yield put({ type: actionTypes.SET_CUSTOMER_BY_AFFILIATEID, payload: [] });
        }
    } catch (error) {
        yield put({ type: actionTypes.SET_CUSTOMER_BY_AFFILIATEID, payload: [] });
        Swal.fire({ icon: 'error', text: error?.response?.data?.message, showConfirmButton: false, timer: 10000 });
    }
};

export default function* adminSaga() {
    //! Partner
    yield takeLeading(actionTypes.GET_PARTNERS, getPartners);
    yield takeLeading(actionTypes.GET_PARTNER_BY_ID, getPartnerById);
    yield takeLeading(actionTypes.CREATE_PARTNER, createPartner);
    yield takeLeading(actionTypes.UPDATE_PARTNER, updatePartner);
    yield takeLeading(actionTypes.DELETE_PARTNER, deletePartner);
    yield takeLeading(actionTypes.CHANGE_PARTNER_STATUS, changePartnerStatus);

    //* Customer
    yield takeLeading(actionTypes.GET_CUSTOMER_BY_PARTNERID, getCustomerByPartnerId);
    yield takeLeading(actionTypes.GET_AFFILIATE_BY_PARTNERID, getAffiliatesByPartnerId);
    yield takeLeading(actionTypes.GET_CUSTOMER_BY_AFFILIATEID, getCustomersByAffiliateId);

    //! Partner Report Wallet
    yield takeLeading(actionTypes.GET_PARTNER_REPORT_WALLETS, getPartnerReportWallets);
    yield takeLeading(actionTypes.CREATE_PARTNER_REPORT_WALLET, createPartnerReportWallet);
    yield takeLeading(actionTypes.UPDATE_PARTNER_REPORT_WALLET, updatePartnerReportWallet);
    yield takeLeading(actionTypes.DELETE_PARTNER_REPORT_WALLET, deletePartnerReportWallet);
};